module.exports = __webpack_public_path__ + "img/logo01.9a1f3a47.png";